import { render, staticRenderFns } from "./DisksVerified.vue?vue&type=template&id=587ccf8b&"
import script from "./DisksVerified.vue?vue&type=script&lang=js&"
export * from "./DisksVerified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports